import { createContext, useState } from 'react';
import * as React from 'react';

const GlobalContext = createContext({
    showMenu: false,
    showMore: false,
    stripeData:"",
    displayMenu: (data: boolean) => { },
    displayMore: () => { },
    StripePayment:(stripeData:any)=>{}
});

export function GlobalContextProvider(props: any) {
    const [showMenu, setshowMenu] = useState(false);
    const [showMore, setshowMore] = useState(false);
    const [stripeData, setStripeData] = useState<any>();
    function StripePayment(stripeData:any){
        setStripeData(stripeData)
    }
    function itemDisplayMenuHandler(data: boolean) {
        if (data) {
            data = false;
        }
        if (showMenu) {
            setshowMenu(false);
        } else {
            setshowMenu(true);
        }
    }

    function itemDisplayMoreHandler() {
        if (showMore) {
            setshowMore(false);
        } else {
            setshowMore(true);
        }
    }
    const context = {
        showMenu: showMenu,
        showMore: showMore,
        displayMenu: itemDisplayMenuHandler,
        displayMore: itemDisplayMoreHandler,
        StripePayment:StripePayment,
        stripeData:stripeData,
    };

    return (
        <GlobalContext.Provider value={context}>
            {props.children}
        </GlobalContext.Provider>
    );
}

export default GlobalContext;
